@if (organizationsRowWithLogo$ | async; as organizationsRowWithLogo) {
  <div class="fx-fill fx-layout-col fx-justify-start fx-align-stretch"
       style="text-align: center"
       id="organizations-container"
  >
    <h3 class="main-title"> {{ 'TITLE.USER_ORGANIZATIONS' | translate }}</h3>
    @for (organizationsRow of organizationsRowWithLogo; track organizationsRow) {
      <div class="fx-layout-row fx-wrap fx-justify-center">
        @for (organizationWithLogo of organizationsRow; track organizationWithLogo) {
          <mat-card class="organization-item fx-layout-row fx-justify-center"
                    tabindex="0"
                    (click)="goToOrganization(organizationWithLogo.organization.id)"
                    (keyup.enter)="goToOrganization(organizationWithLogo.organization.id)">
            <mat-card-content class="organization-content fx-layout-col fx-justify-center fx-align-center">
              <div [style.background-image]="organizationWithLogo.logoUrl" class="organization-profile-picture"></div>
              <span class="organization-name">{{ organizationWithLogo.organization.name }}</span>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
    @if (userBiReports$ | async; as userBiReports) {
      <h3 class="main-title"> {{ 'TITLE.GLOBAL_BI_REPORTS' | translate }}</h3>
      <div class="fx-layout-row fx-wrap fx-justify-center">
        @for (userBiReport of userBiReports; track userBiReport.id) {
          <mat-card
            class="organization-item fx-layout-row fx-justify-center fx-align-center"
            tabindex="0"
            (click)="navigateToUserBiReport(userBiReport)"
            (keyup.enter)="navigateToUserBiReport(userBiReport)">
            <mat-card-content class="organization-content fx-layout-col fx-justify-center fx-align-center">
              <mat-icon fontSet="mdi" fontIcon="mdi-file-chart-outline" class="fx-fill xl"></mat-icon>
              <span class="organization-name">{{ userBiReport.name | uppercase | translate }}</span>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  </div>
} @else {
  <spinner></spinner>
}

